module.exports = __webpack_public_path__ + "img/kvalitetselement_biologiske.c4bf1a24.jpg";